exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/author-widget.js-WebpackMultiOutput";